export default {
  methods: {
    // 获取returnUrl
    getReturnUrl() {
      // 必须要保证returnUrl 是 encodeURIComponent 过的, 否则会丢参数
      // 从查询字符串中获取 returnUrl 或 ReturnUrl 参数的值
      let urlParams = new URLSearchParams(window.location.search)
      let returnUrl = urlParams.get('returnUrl') || urlParams.get('ReturnUrl')
      let defaultReturnUrl = new URL('//www.jdcloud.com', window.location.origin).origin
      // 定义用于匹配域名的正则表达式
      let domainRegex = /\.jcloud\.com|\.jdcloud\.com|facerec\.jd\.com|neuhub\.jd\.com|\.jd\.com/

      // 检查 returnUrl 是否存在
      if (returnUrl) {
        // 对 returnUrl 进行解码
        returnUrl = decodeURIComponent(returnUrl)

        // 提取 returnUrl 中的域名部分
        let domainMatch = returnUrl.match(domainRegex)

        // 检查域名是否符合正则表达式
        if (!domainMatch) {
          // 返回原始的 returnUrl
          returnUrl = defaultReturnUrl
        }
      } else {
        returnUrl = defaultReturnUrl
      }
      return encodeURIComponent(returnUrl)
    }
  }
}
